import { render, staticRenderFns } from "./FootItem.vue?vue&type=template&id=67f60eb4&scoped=true"
import script from "./FootItem.vue?vue&type=script&lang=js"
export * from "./FootItem.vue?vue&type=script&lang=js"
import style0 from "./FootItem.vue?vue&type=style&index=0&id=67f60eb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f60eb4",
  null
  
)

export default component.exports